function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import CheckboxItem from './CheckboxItem';
import CollapseIcon from './CollapseIcon';
import { COLLAPSE_ICON_POSITION } from '../constants';
const Item = props => {
  const {
    treeNode = {},
    showCollapseIcon,
    collapseIconPos = COLLAPSE_ICON_POSITION.LEFT,
    disabled = false,
    isCollapseIconExpanded = false,
    iconColor,
    checkable = false,
    onCollapseIconClick,
    onChange = () => {},
    children,
    ...restProps
  } = props;
  const {
    id: itemId = ''
  } = treeNode;
  const collapseIconProps = {
    itemId: itemId,
    isNodeItem: !!treeNode?.nodeItem,
    isIconExpanded: isCollapseIconExpanded,
    onClick: onCollapseIconClick,
    color: iconColor
  };
  return /*#__PURE__*/React.createElement("div", _extends({}, restProps, {
    disabled: disabled
  }), showCollapseIcon && collapseIconPos === COLLAPSE_ICON_POSITION.LEFT ? /*#__PURE__*/React.createElement(CollapseIcon, collapseIconProps) : null, checkable ? /*#__PURE__*/React.createElement(CheckboxItem, {
    treeNode: treeNode,
    onChange: onChange,
    disabled: disabled
  }) : children, showCollapseIcon && collapseIconPos === COLLAPSE_ICON_POSITION.RIGHT ? /*#__PURE__*/React.createElement(CollapseIcon, collapseIconProps) : null);
};
Item.propTypes = {
  treeNode: PropTypes.object,
  showCollapseIcon: PropTypes.bool,
  disabled: PropTypes.bool,
  isCollapseIconExpanded: PropTypes.bool,
  checkable: PropTypes.bool,
  collapseIconPos: PropTypes.oneOf([COLLAPSE_ICON_POSITION.LEFT, COLLAPSE_ICON_POSITION.RIGHT]),
  iconColor: PropTypes.string,
  onCollapseIconClick: PropTypes.func,
  onChange: PropTypes.PropTypes.func,
  children: PropTypes.node
};
export default Item;